var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card-Template",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selling-desktop",
    transform: "translate(-1487.000000, -164.000000)",
    fill: "#727272",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1487.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4893617,15.613579 C6.28368794,17.5736834 3.4751773,15.9869322 3.4751773,15.9869322 C3.4751773,15.9869322 3.03546099,16.4136216 2.65248227,16.7736408 C2.26950355,17.1603281 2.09929078,17.0269876 2.04255319,16.5602961 C1.94326241,15.4402365 1.74468085,13.4001278 1.74468085,13.4001278 C1.74468085,13.4001278 3.68794326,13.4001278 4.87943262,13.4001278 C5.46099291,13.4001278 5.73049645,13.5334682 5.20567376,14.0534959 C4.83687943,14.4535172 4.45390071,14.8802066 4.45390071,14.8802066 C4.45390071,14.8802066 6.63829787,15.6535812 8.70921986,14.3201768 C10.212766,13.3601257 10.4539007,11.3866873 10.4539007,10.986666 C10.4539007,10.5999787 10.6382979,10.4266361 11.035461,10.4266361 C11.4326241,10.4266361 11.0638298,10.4266361 11.4184397,10.4266361 C11.8014184,10.4266361 12,10.6266468 12,10.986666 C12,11.3466851 11.929078,14.1201662 9.4893617,15.613579 Z M6.79432624,7.94650406 C7.16312057,7.54648275 7.54609929,7.11979337 7.54609929,7.11979337 C7.54609929,7.11979337 5.36170213,6.34641885 3.29078014,7.67982319 C1.78723404,8.63987432 1.54609929,10.6133127 1.54609929,11.013334 C1.54609929,11.4000213 1.36170213,11.5733639 0.964539007,11.5733639 C0.567375887,11.5733639 0.936170213,11.5733639 0.581560284,11.5733639 C0.19858156,11.5733639 0,11.3733532 0,11.013334 C0,10.6666489 0.0709219858,7.89316788 2.5106383,6.38642098 C5.71631206,4.41298255 8.5248227,6.01306776 8.5248227,6.01306776 C8.5248227,6.01306776 8.96453901,5.58637837 9.34751773,5.2263592 C9.73049645,4.83967194 9.90070922,4.97301238 9.95744681,5.43970389 C10.0567376,6.55976354 10.2553191,8.59987218 10.2553191,8.59987218 C10.2553191,8.59987218 8.31205674,8.59987218 7.12056738,8.59987218 C6.53900709,8.59987218 6.26950355,8.46653175 6.79432624,7.94650406 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.20117d0878ee0e9950998cc8f78c237d.svg";
export { ForwardRef as ReactComponent };